import React, { useEffect, useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { toast } from "sonner";
import UploadButton from "../components/UploadButton";
import { BookingBadge } from "../components/Badges";
import Seo from "../components/Seo";

const navItems = [
  { to: "/dashboard", label: "Overview", end: true },
  { to: "/dashboard/profile", label: "Profile" },
  { to: "/dashboard/portfolio", label: "Portfolio" },
  { to: "/dashboard/bookings", label: "Bookings" },
  { to: "/dashboard/aftercare", label: "Aftercare" },
  { to: "/dashboard/saved", label: "Saved" },
  { to: "/dashboard/blog", label: "My posts" },
];

// export function DashboardLayout() {
//   const { user } = useAuth();

//   console.log({user})
//   return (
//     <div className="container-x py-10 grid md:grid-cols-[220px_1fr] gap-10" data-testid="dashboard-layout">
//       <aside>
//         <div className="card">
//           <div className="font-serif text-lg" data-testid="dash-greeting">Hi, {user?.name?.split(" ")[0]}</div>
//           <p className="text-xs text-black/60 mt-1 capitalize">{user?.account_type}</p>
//           {user?.account_type === "artist" && <div className="mt-2"><BookingBadge status={user?.booking_status} /></div>}
//         </div>
//         <nav className="mt-6 flex flex-col gap-1">
//           {navItems.map((n) => {

//           if(user.account_type === "client" && n.to === "/dashboard/portfolio") return

//           return   (
//             <NavLink key={n.to} to={n.to} end={n.end}
//               className={({ isActive }) => `text-sm py-2 px-3 rounded-[8px] ${isActive ? "bg-black text-white" : "hover:bg-black/5"}`}
//               data-testid={`dash-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
//               {n.label}
//             </NavLink>
//           )
//           })}
//           {user?.role === "admin" && (
//             <NavLink to="/admin/flags" className={({ isActive }) => `text-sm py-2 px-3 rounded-[8px] ${isActive ? "bg-black text-white" : "hover:bg-black/5"}`} data-testid="dash-nav-admin">Admin: Flags</NavLink>
//           )}
//         </nav>
//       </aside>
//       <main><Outlet /></main>
//     </div>
//   );
// }


export function DashboardLayout() {
  const { user } = useAuth();

  return (
    <div
      className="container-x py-6 md:py-10 grid md:grid-cols-[220px_1fr] gap-6 md:gap-10"
      data-testid="dashboard-layout"
    >
      <Seo title="Dashboard" noindex/>
      <aside className="min-w-0">
        <div className="card">
          <div className="font-serif text-lg" data-testid="dash-greeting">
            Hi, {user?.name?.split(" ")[0]}
          </div>

          <p className="text-xs text-black/60 mt-1 capitalize">
            {user?.account_type}
          </p>

          {user?.account_type === "artist" && (
            <div className="mt-2">
              <BookingBadge status={user?.booking_status} />
            </div>
          )}
        </div>

        <nav
          className="
            mt-4 md:mt-6
            flex flex-row md:flex-col
            gap-1
            overflow-x-auto
            md:overflow-visible
            whitespace-nowrap
            pb-1 md:pb-0
            scrollbar-none
          "
        >
          {navItems.map((n) => {
            if (
              user?.account_type === "client" &&
              n.to === "/dashboard/portfolio"
            ) {
              return null;
            }

            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `text-sm py-2 px-3 rounded-[8px] shrink-0 ${isActive
                    ? "bg-black text-white"
                    : "hover:bg-black/5"
                  }`
                }
                data-testid={`dash-nav-${n.label
                  .toLowerCase()
                  .replace(/\s/g, "-")}`}
              >
                {n.label}
              </NavLink>
            );
          })}

          {user?.role === "admin" && (
            <NavLink
              to="/admin/flags"
              className={({ isActive }) =>
                `text-sm py-2 px-3 rounded-[8px] shrink-0 ${isActive
                  ? "bg-black text-white"
                  : "hover:bg-black/5"
                }`
              }
              data-testid="dash-nav-admin"
            >
              Admin: Flags
            </NavLink>
          )}
        </nav>
      </aside>

      <main className="min-w-0">
        <Outlet />
      </main>
    </div>
  );
}


export function DashboardHome() {
  const { user } = useAuth();
  return (
    <div data-testid="dash-overview">
      <h1 className="font-serif text-3xl">Overview</h1>
      <p className="text-black/60 mt-2">Welcome back to your studio space.</p>
      <div className="grid md:grid-cols-3 gap-4 mt-8">
        <Link to="/dashboard/profile" className="card hover:-translate-y-0.5 transition-transform" data-testid="quick-profile">
          <div className="font-medium">Profile</div>
          <p className="text-sm text-black/60 mt-1">Bio, location, style tags, avatar.</p>
        </Link>
        {user?.account_type === "artist" && (
          <Link to="/dashboard/portfolio" className="card hover:-translate-y-0.5 transition-transform" data-testid="quick-portfolio">
            <div className="font-medium">Portfolio</div>
            <p className="text-sm text-black/60 mt-1">Manage your gallery + booking status.</p>
          </Link>
        )}
        <Link to="/dashboard/bookings" className="card hover:-translate-y-0.5 transition-transform" data-testid="quick-bookings">
          <div className="font-medium">Bookings</div>
          <p className="text-sm text-black/60 mt-1">Incoming, upcoming, past.</p>
        </Link>
        <Link to="/dashboard/blog" className="card hover:-translate-y-0.5 transition-transform" data-testid="quick-blog">
          <div className="font-medium">My posts</div>
          <p className="text-sm text-black/60 mt-1">Drafts, published, stats.</p>
        </Link>
      </div>
    </div>
  );
}

export function ProfileEdit() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", username: user?.username || "", bio: user?.bio || "", location: user?.location || "", avatar_url: user?.avatar_url || "", style_tags: (user?.style_tags || []).join(", "), booking_status: user?.booking_status || "open", instagram_handle: user?.instagram_handle || "" });
  const [saving, setSaving] = useState(false);
  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const payload = { ...form, style_tags: form.style_tags.split(",").map(s => s.trim()).filter(Boolean) };
      await api.patch("/users/me", payload); await refresh(); toast.success("Profile updated");
    } catch { toast.error("Could not save"); } finally { setSaving(false); }
  };
  return (
    <div data-testid="profile-edit">
      <h1 className="font-serif text-3xl">Edit profile</h1>
      <form onSubmit={save} className="mt-8 space-y-4 max-w-xl">
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-full bg-neutral-200 overflow-hidden">{form.avatar_url && <img src={form.avatar_url} alt="" className="w-full h-full object-cover" />}</div>
          <UploadButton onUploaded={(url) => setForm({ ...form, avatar_url: url })} label="Upload avatar" testId="profile-avatar-upload" />
        </div>
        <div><label className="text-sm font-medium block mb-1.5">Display name</label><input required className="input-field" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="profile-name" /></div>
        <div><label className="text-sm font-medium block mb-1.5">Username</label><input required className="input-field" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} data-testid="profile-username" /></div>
        <div><label className="text-sm font-medium block mb-1.5">Location</label><input className="input-field" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} data-testid="profile-location" /></div>
        <div><label className="text-sm font-medium block mb-1.5">Bio</label><textarea rows={4} className="input-field" value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} data-testid="profile-bio" /></div>
        <div>
          <label className="text-sm font-medium block mb-1.5">Instagram handle</label>
          <div className="flex items-center border-[0.5px] border-black/20 rounded-[8px] px-3">
            <span className="text-black/50 text-sm">@</span>
            <input className="flex-1 py-2 px-1 bg-transparent outline-none text-base" value={form.instagram_handle} onChange={(e) => setForm({ ...form, instagram_handle: e.target.value })} placeholder="yourhandle" data-testid="profile-instagram" />
          </div>
          <p className="text-xs text-black/50 mt-1">Shown as a link on your public profile.</p>
        </div>
        {user?.account_type === "artist" && (
          <>
            <div><label className="text-sm font-medium block mb-1.5">Style tags (comma-separated)</label><input className="input-field" value={form.style_tags} onChange={(e) => setForm({ ...form, style_tags: e.target.value })} placeholder="Neo-traditional, Japanese" data-testid="profile-styles" /></div>
            <div>
              <label className="text-sm font-medium block mb-1.5">Booking status</label>
              <div className="flex gap-2">
                {["open", "waitlist", "flash"].map((s) => (
                  <button key={s} type="button" onClick={() => setForm({ ...form, booking_status: s })} className={`badge ${form.booking_status === s ? "badge-flash" : "badge-neutral"}`} data-testid={`status-${s}`}>{s}</button>
                ))}
              </div>
            </div>
          </>
        )}
        <button className="btn-filled" disabled={saving} data-testid="profile-save">{saving ? "Saving..." : "Save changes"}</button>
      </form>
    </div>
  );
}

export function PortfolioManage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", style_tag: "Neo-traditional", image_url: "" });
  const load = () => api.get("/portfolio/me").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  if (user?.account_type !== "artist") return <div>Portfolio is for artists.</div>;
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/portfolio", form); setForm({ title: "", style_tag: "Neo-traditional", image_url: "" }); load(); toast.success("Added"); } catch { toast.error("Failed"); }
  };
  const del = async (id) => { await api.delete(`/portfolio/${id}`); load(); };
  return (
    <div data-testid="portfolio-manage">
      <h1 className="font-serif text-3xl">Portfolio</h1>
      <form onSubmit={add} className="card mt-6 space-y-3" data-testid="portfolio-form">
        <div><label className="text-sm font-medium block mb-1.5">Title</label><input required className="input-field" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="port-title" /></div>
        <div><label className="text-sm font-medium block mb-1.5">Style</label>
          <select className="input-field" value={form.style_tag} onChange={(e) => setForm({ ...form, style_tag: e.target.value })} data-testid="port-style">
            {["Traditional", "Neo-traditional", "Japanese", "Blackwork", "Watercolor", "Geometric", "Realism", "Minimalist"].map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
        <div><label className="text-sm font-medium block mb-1.5">Image</label>
          <div className="flex gap-2"><input required className="input-field" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} placeholder="https://..." data-testid="port-img" />
            <UploadButton onUploaded={(url) => setForm({ ...form, image_url: url })} label="Upload" testId="port-upload" />
          </div>
        </div>
        <button className="btn-filled" data-testid="port-submit">Add piece</button>
      </form>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-8">
        {items.map((p) => (
          <div key={p.id} className="card !p-0 overflow-hidden">
            <div className="aspect-square overflow-hidden"><img src={p.image_url} alt={p.title} className="w-full h-full object-cover" /></div>
            <div className="p-3 flex items-center justify-between">
              <div>
                <div className="text-sm font-medium truncate">{p.title}</div>
                <span className="badge badge-neutral mt-1">{p.style_tag}</span>
              </div>
              <button onClick={() => del(p.id)} className="text-xs text-red-700 underline" data-testid={`port-del-${p.id}`}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function BookingsManage() {
  const { user } = useAuth();
  const [incoming, setIncoming] = useState([]);
  const [mine, setMine] = useState([]);
  const load = () => {
    if (user?.account_type === "artist") api.get("/bookings/incoming").then((r) => setIncoming(r.data));
    api.get("/bookings/mine").then((r) => setMine(r.data));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [user]);
  const setStatus = async (id, status) => { await api.patch(`/bookings/${id}`, { status }); load(); toast.success(status); };
  return (
    <div data-testid="bookings-manage">
      <h1 className="font-serif text-3xl">Bookings</h1>
      {user?.account_type === "artist" && (
        <>
          <h2 className="font-serif text-xl mt-8">Incoming requests</h2>
          <div className="space-y-3 mt-3">
            {incoming.map((b) => (
              <div key={b.id} className="card" data-testid={`incoming-${b.id}`}>
                <div className="flex items-center justify-between">
                  <div className="font-medium">{b.client_name} · {b.preferred_date}</div>
                  <span className="badge badge-neutral">{b.status}</span>
                </div>
                <p className="text-sm text-black/70 mt-1">Placement: {b.body_placement}</p>
                <p className="text-sm text-black/70 mt-1">{b.description}</p>
                {b.reference_image_url && <img src={b.reference_image_url} alt="" className="max-h-40 rounded-[8px] mt-2" />}
                <div className="flex gap-2 mt-3">
                  {b.status === "pending" && <>
                    <button onClick={() => setStatus(b.id, "accepted")} className="btn-filled" data-testid={`accept-${b.id}`}>Accept</button>
                    <button onClick={() => setStatus(b.id, "declined")} className="btn-outline" data-testid={`decline-${b.id}`}>Decline</button>
                  </>}
                  {b.status === "accepted" && <button onClick={() => setStatus(b.id, "completed")} className="btn-filled" data-testid={`complete-${b.id}`}>Mark completed</button>}
                </div>
              </div>
            ))}
            {incoming.length === 0 && <p className="text-black/50 text-sm">No incoming requests.</p>}
          </div>
        </>
      )}
      <h2 className="font-serif text-xl mt-10">My appointments</h2>
      <div className="space-y-3 mt-3">
        {mine.map((b) => (
          <div key={b.id} className="card" data-testid={`mine-${b.id}`}>
            <div className="flex items-center justify-between">
              <div className="font-medium">With {b.artist_name} · {b.preferred_date}</div>
              <span className="badge badge-neutral">{b.status}</span>
            </div>
            <p className="text-sm text-black/70 mt-1">{b.body_placement} · {b.description}</p>
            {b.status === "pending" && <button onClick={() => setStatus(b.id, "cancelled")} className="btn-outline mt-3" data-testid={`cancel-${b.id}`}>Cancel</button>}
          </div>
        ))}
        {mine.length === 0 && <p className="text-black/50 text-sm">No appointments yet.</p>}
      </div>
    </div>
  );
}

const STAGES = [
  ["day_1_3", "Day 1–3", ["Keep bandage on as advised", "Wash with mild soap", "Pat dry — no rubbing"]],
  ["day_4_7", "Day 4–7", ["Light moisturizer 2x/day", "Avoid sun and submersion", "Don't pick scabs"]],
  ["week_2", "Week 2", ["Itching may peak", "Keep moisturized", "Avoid tight clothing on area"]],
  ["week_3_4", "Week 3–4", ["Surface healing", "Color may look hazy — normal", "Continue moisturizing"]],
  ["month_2_plus", "Month 2+", ["Fully healed surface", "Use sunscreen on tattoo", "Touch-ups if needed"]],
];

export function AftercarePage() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/aftercare/mine").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const update = async (id, stage, payload) => { await api.patch(`/aftercare/${id}`, { stage, ...payload }); load(); };
  return (
    <div data-testid="aftercare-page">
      <h1 className="font-serif text-3xl">Aftercare</h1>
      <p className="text-black/60 mt-2">Your healing timeline for each completed session.</p>
      <div className="space-y-8 mt-8">
        {items.map((a) => (
          <div key={a.id} className="card" data-testid={`aftercare-${a.id}`}>
            <div className="font-medium">{a.body_placement} · with {a.artist_name}</div>
            <div className="mt-6 space-y-6">
              {STAGES.map(([key, label, defaults]) => {
                const data = a.stages[key] || { checks: [], notes: "" };
                return (
                  <div key={key} className="border-l-[0.5px] border-black/20 pl-4">
                    <div className="font-serif text-lg">{label}</div>
                    <ul className="mt-2 space-y-1.5">
                      {defaults.map((d, i) => (
                        <li key={i} className="text-sm flex items-center gap-2">
                          <input type="checkbox" checked={data.checks.includes(d)}
                            onChange={(e) => {
                              const checks = e.target.checked ? [...data.checks, d] : data.checks.filter(x => x !== d);
                              update(a.id, key, { checks });
                            }}
                            data-testid={`check-${a.id}-${key}-${i}`} />
                          <span>{d}</span>
                        </li>
                      ))}
                    </ul>
                    <textarea rows={2} defaultValue={data.notes} placeholder="Notes (e.g. started peeling day 3)"
                      className="input-field mt-2 text-sm"
                      onBlur={(e) => update(a.id, key, { notes: e.target.value })}
                      data-testid={`notes-${a.id}-${key}`} />
                  </div>
                );
              })}
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-black/50">No completed sessions yet. Aftercare timelines appear after an artist marks your booking completed.</p>}
      </div>
    </div>
  );
}

export function SavedPage() {
  const [insp, setInsp] = useState([]);
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/inspiration/mine").then((r) => setInsp(r.data));
    api.get("/blog/saved/mine").then((r) => setPosts(r.data));
  }, []);
  return (
    <div data-testid="saved-page">
      <h1 className="font-serif text-3xl">Saved</h1>
      <h2 className="font-serif text-xl mt-8">Inspiration board</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3">
        {insp.map((p) => (
          <div key={p.id} className="card !p-0 overflow-hidden">
            <div className="aspect-[3/4] overflow-hidden"><img src={p.image_url} alt={p.title} className="w-full h-full object-cover" /></div>
            <div className="p-3 text-xs"><div className="font-medium truncate">{p.title}</div><div className="text-black/60">{p.artist_name}</div></div>
          </div>
        ))}
        {insp.length === 0 && <p className="text-black/50 col-span-full text-sm">Save pieces from /explore.</p>}
      </div>
      <h2 className="font-serif text-xl mt-10">Saved posts</h2>
      <div className="space-y-3 mt-3">
        {posts.map((b) => (
          <Link to={`/blog/${b.slug}`} key={b.id} className="card block hover:-translate-y-0.5 transition-transform">
            <span className="badge badge-neutral">{b.category}</span>
            <div className="font-serif text-lg mt-2">{b.title}</div>
            <div className="text-xs text-black/60 mt-1">{b.author_name}</div>
          </Link>
        ))}
        {posts.length === 0 && <p className="text-black/50 text-sm">No saved posts yet.</p>}
      </div>
    </div>
  );
}

export function MyBlogPosts() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/blog/posts/mine").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="my-blog">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl">My posts</h1>
        <Link to="/blog/new" className="btn-filled" data-testid="my-blog-new">Write new</Link>
      </div>
      <div className="space-y-3 mt-6">
        {items.map((b) => (
          <div key={b.id} className="card flex items-center justify-between" data-testid={`my-blog-${b.id}`}>
            <div>
              <div className="flex gap-2 items-center"><span className={`badge ${b.status === "published" ? "badge-open" : "badge-waitlist"}`}>{b.status}</span><span className="badge badge-neutral">{b.category}</span></div>
              <div className="font-serif text-lg mt-2">{b.title || "Untitled"}</div>
              <div className="text-xs text-black/60 mt-1">{b.views || 0} views · {(b.likes || []).length} likes</div>
            </div>
            <div className="flex gap-2">
              {b.status === "published" && <Link to={`/blog/${b.slug}`} className="btn-outline">View</Link>}
              <Link to={`/blog/${b.slug}/edit`} className="btn-outline">Edit</Link>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-black/50 text-sm">No posts yet.</p>}
      </div>
    </div>
  );
}
